import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HostelService {

  constructor(public http: HttpClient) { }

  public getSessions() {
    return this.http.get<any>("/edozzier/hostel/portal-get-sessions.php");
  }

  public getStudentHostels() {
    return this.http.get<any>("/edozzier/hostel/portal-get-student-hostels.php");
  }

  public getHostels() {
    return this.http.get<any>("/edozzier/hostel/portal-get-hostels.php");
  }

  public addHostel(data) {
    return this.http.post<any>("/edozzier/hostel/portal-add-hostel.php", data);
  }


}
